import { Component, OnInit, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import _moment from 'proxies/dayjs';
import { CommunicationService } from 'src/modules/base/services/communication.service';
import { Subject, Subscription } from 'rxjs'
import { BaseService } from 'src/modules/base/shared/services/base.service';
import { RolePermissionService } from 'src/modules/base/shared/services/role-permission.service';
import { AppService } from 'src/modules/base/shared/services/app.service';
import { debounceTime, distinctUntilChanged, shareReplay } from 'rxjs/operators';
import { AlertsService } from 'src/modules/base/services/alerts.service';
import { ActivatedRoute } from '@angular/router';
import { KeyValue } from '@angular/common';
import { CommonService } from 'src/modules/base/services/common.service';
import { AuthenticationService } from 'src/modules/base/shared/services/authentication.service';
import { PreferenceService } from 'src/modules/base/shared/services/preference.service';

@Component({
  selector: 'time-slots',
  templateUrl: './time-slots.component.html',
  styleUrls: ['./time-slots.component.scss'],
  standalone: false
})
export class TimeSlotsComponent implements OnInit, OnDestroy {
  timeSlots: any; timing: any;
  @Input() hasAppliedCss: boolean = false
  @Input() duration: number;
  @Input() multipleSlots: boolean = false;
  finalslot: any; hideToolTip: boolean = false;
  @Input() colorScheme: any = {};
  @Input() autoSelectedSlots: any;
  @Input() slotTimingInfo: boolean = false;
  @Input() releaseSlot: boolean = false;
  @Input() styleclass: any = 0;
  patientDetail: any;
  submitButton: boolean = true;
  @Input() errorMessage: any;
  @Input() slot_selection_limit: any
  @Input() selectedPriority: any
  selectedSlots: any;
  @Input() public set slots(val: any) {
    if (val) {
      this.timeSlots = val;
      this.Arr = [];
      this.multipleCheckArray = [];
    }
  }
  @Input() key: any;
  @Output() slotResult = new EventEmitter<any>();
  Arr: any[] = [];
  Arra_data: any[] = [];
  multipleCheckArray: any[] = [];
  //ArrSlotEndTime: any[] = [];
  final_end_time: any;
  showSpinner: boolean = true
  moment = _moment;
  originalOrder = (a: KeyValue<number, string>, b: KeyValue<number, string>): number => {
    return 0;
  }
  currentTime: any; subscrib_slot_info: Subscription;
  subscription: Subscription;
  checkDetail: any = [];
  getSubject: Subject<any> = new Subject();
  closepopup: boolean = false;
  status: any = "Available"
  subscription_date: Subscription;

  constructor(
    private communicationService: CommunicationService,
    private baseService: BaseService,
    public checkP: RolePermissionService,
    private alertService: AlertsService,
    private appService: AppService,
    public route: ActivatedRoute,
    private commonService: CommonService,
    private auth: AuthenticationService,
    private prefernceService: PreferenceService
  ) {
    this.subscription = this.communicationService.resetChangeEmitted$.subscribe(
      data => {
        console.log('reset data is as ::', data)
        if (data.reset == true) {
          // this.Arr = []
          this.resetColor()
        }
      }
    )

    this.subscription_date = this.communicationService.getMultipleSlotCount$.subscribe(data => {
      if (data) {
        this.setAppointment(data);
      }
    })
  }

  ngOnInit() {
    this.currentTime = this.moment().utc().valueOf();
    this.Arr = [];
    this.Arra_data = [];
    this.hideToolTip = this.prefernceService.checkCommonConfigEnabled('hide_patient_details') ? this.prefernceService.checkCommonConfigEnabled('hide_patient_details') : false;
    //this.ArrSlotEndTime = [];
    // this.slots.forEach(elem => {
    //   let myDate: any = new Date(elem.slot_start_time);
    //   let startTime = new Date(myDate - myDate.getTimezoneOffset() * 60000)
    //   elem.slot_start_time = new Date(startTime).valueOf();
    // })
    // console.log("slots are ", this.timeSlots);
    this.getSubject.pipe(distinctUntilChanged((prev, curr) => prev === curr))
      .subscribe((event) => {
        if (event) {
          this.getSlotDetail(event);
        }
      })
    if (this.autoSelectedSlots != undefined && this.autoSelectedSlots != "") {
      this.autoSelectedSlot();
    }
  }

  autoSelectedSlot() {
    this.selectedSlots = this.timeSlots.find(x => (x.slot_start_time == this.autoSelectedSlots.service_start_time))
    this.slotResult.emit(this.selectedSlots);
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
    this.subscription_date.unsubscribe();
  }

  cheklength() {
    if (Object.keys(this.colorScheme).length == 0) {
      return true
    } else {
      return false
    }
  }

  onHoverSlotTiming(slot: any) {
    this.timing = slot
  }

  openpopup() {
    return this.closepopup = !this.closepopup
  }

  setAppointment(slot) {
    if (slot.status != 'available' || slot.slot_end_time < this.currentTime)
      return
    if (slot.hasOwnProperty("reason"))
      return
    slot = this.getMultipleSlotSelection(slot)
    this.Arr.push("selected_slot" + slot.id + slot.slot_start_time)
    if (this.Arr.length > 1) {
      for (let i = 0; i < this.Arr.length - 1; i++) {
        let selectedSlot: HTMLElement = document.getElementById(this.Arr[i]);
        if (selectedSlot) {
          selectedSlot.style.background = "white";
        }
      }
    }

    if (this.duration != undefined && this.multipleSlots == false) {
      this.Arra_data = [];
      slot.slot_end_time = slot.slot_start_time + this.duration;
      for (let i = 0; i < this.timeSlots.length; i++) {
        let selectedEndSlot: HTMLElement = document.getElementById("selected_slot" + this.timeSlots[i].id + this.timeSlots[i].slot_start_time);
        if (selectedEndSlot != undefined && this.timeSlots[i].status != 'booked' && this.timeSlots[i].slot_start_time > this.currentTime) {
          selectedEndSlot.style.background = "white";
        }
        if (this.timeSlots[i].slot_start_time >= slot.slot_start_time && this.timeSlots[i].slot_start_time <= slot.slot_end_time && this.timeSlots[i].status == 'available') {
          this.Arra_data.push(this.timeSlots[i].slot_start_time);
          let selectedEndSlot: HTMLElement = document.getElementById("selected_slot" + this.timeSlots[i].id + this.timeSlots[i].slot_start_time);
          if (selectedEndSlot != undefined) {
            this.final_end_time = this.timeSlots[i].slot_end_time;
            selectedEndSlot.style.background = "#5CBAF1";
          }
        }
      }
      slot.slot_end_time = this.final_end_time;
    }
    if (this.multipleSlots) {
      const allSlots = [].concat(...Object.values(this.timeSlots || {}).map(d => [].concat(...Object.values(d || {}))));
      // Find last slot with overbooking enabled
      allSlots.forEach(slot => {
        if (slot.last_slot_overbooking === true && slot.schedule_service_multiplier) {
          [...Array(parseInt(slot.last_slot_overbooking_count))].forEach((_, i) => {
            allSlots.push(JSON.parse(JSON.stringify(slot)));
          });
        }
      });
      let targetSlotIndex = allSlots.findIndex(e => e?.id === slot?.id);
      // If end index goes outside array → throw error
      if (targetSlotIndex !== -1 && this.slot_selection_limit && slot.schedule_service_multiplier && (targetSlotIndex + this.slot_selection_limit) > allSlots.length) {
        this.clearSlotSelection(this.Arr)
        this.alertService.error("This appointment requires more time than available slots. Please select another slot.");
        return;
      }
      if (targetSlotIndex !== -1 && this.slot_selection_limit && slot.schedule_service_multiplier && targetSlotIndex + this.slot_selection_limit <= allSlots.length) {
        const result = allSlots.slice(targetSlotIndex, targetSlotIndex + this.slot_selection_limit);
        const bookedSlots = result.filter(slot => slot?.status !== 'available');
        if (bookedSlots.length > 0) {
          this.clearSlotSelection(this.Arr)
          this.alertService.error("This appointment requires more time than available slots. Please select another slot.");
          return;
        }
        for (let i = 0; i < result.length; i++) {
          this.Arr.push("selected_slot" + result[i].id + result[i].slot_start_time)
          let selectedEndSlot: HTMLElement = document.getElementById("selected_slot" + result[i].id + result[i].slot_start_time)
          if (selectedEndSlot) selectedEndSlot.style.background = "#5CBAF1";
        }
        if (slot.slotFound) {
          result.map(s => s['slotFound'] = true);
        }
        this.slotResult.emit(result);
        return;
      }
      if (this.Arra_data.indexOf(slot.id + slot.slot_start_time) > -1) {
        this.Arra_data.splice(this.Arra_data.indexOf(slot.id + slot.slot_start_time), 1);
        this.multipleCheckArray.splice(this.multipleCheckArray.indexOf(slot.slot_start_time), 1);
        if (this.Arra_data.length > 0) {
          for (let i = 0; i < this.Arra_data.length; i++) {
            let selectedEndSlot: HTMLElement = document.getElementById("selected_slot" + this.Arra_data[i]);
            if (selectedEndSlot != undefined) {
              selectedEndSlot.style.background = "#5CBAF1";
            }
          }
        }
        let selectedSlot: HTMLElement = document.getElementById("selected_slot" + slot.id + slot.slot_start_time);
        selectedSlot.style.background = "white";
      }
      else {
        this.Arra_data.push(slot.id + slot.slot_start_time);
        this.multipleCheckArray.push(slot.slot_start_time);
        if (this.Arra_data.length > 0) {
          for (let i = 0; i < this.Arra_data.length; i++) {
            let selectedEndSlot: HTMLElement = document.getElementById("selected_slot" + this.Arra_data[i]);
            if (selectedEndSlot != undefined) {
              selectedEndSlot.style.background = "#5CBAF1";
            }
          }
        }
      }
      this.Arra_data = this.Arra_data.sort();
      this.multipleCheckArray = this.multipleCheckArray.sort();
      if (this.multipleCheckArray.length > 1) {
        for (let i = this.multipleCheckArray.length; i > 1; i--) {
          if (this.multipleCheckArray[i - 1] - this.multipleCheckArray[i - 2] != slot.slot_end_time - slot.slot_start_time) {
            this.alertService.error("Please Choose Consecutive Slot");
            this.submitButton = false
            if (this.releaseSlot) {
              for (let i = 0; i < this.Arra_data.length - 1; i++) {
                let selectedSlot: HTMLElement = document.getElementById("selected_slot" + this.Arra_data[i]);
                if (selectedSlot != undefined) {
                  selectedSlot.style.background = "white";
                }
                this.Arra_data = []  // remove selected slot and 
                this.Arra_data.push(slot.id + slot.slot_start_time); // then add selected data
                this.multipleCheckArray = []
                this.multipleCheckArray.push(slot.slot_start_time);
                selectedSlot.style.background = "#5CBAF1";
              }
            }
            break;
          }
          else {
            this.submitButton = true
          }
        }
      }
      let slot_start_time;  // sent Data slot_start_time for slotResult
      if (this.releaseSlot != false) {
        slot_start_time = slot.slot_start_time;
      } else {
        slot_start_time = this.multipleCheckArray[0];
      }
      let final_slot_date: any;
      let final_end_slot_time: any;
      // let final_id: any;
      var last = this.multipleCheckArray[this.multipleCheckArray.length - 1]
      for (let i = 0; i < this.timeSlots.length; i++) {
        if (last == this.timeSlots[i].slot_start_time) {
          final_end_slot_time = this.timeSlots[i].slot_end_time;
          final_slot_date = this.timeSlots[i].slot_date;
        }
      }

      this.finalslot = {
        "id": slot.id,
        "slot_date": final_slot_date,
        "slot_start_time": slot_start_time,
        "slot_end_time": this.submitButton ? final_end_slot_time : undefined,
        "consecutive_slot_error": this.submitButton
      }

      this.slotResult.emit(this.finalslot);
    }
    if (this.multipleSlots != true) {
      let selectedSlot: HTMLElement = document.getElementById("selected_slot" + slot.id + slot.slot_start_time);
      if (selectedSlot != null)
        selectedSlot.style.background = "#5CBAF1";

      this.slotResult.emit(slot);
    }
  }
  resetColor() {
    if (this.Arr.length > 0) {
      for (let id of this.Arr) {
        const el = id && document.getElementById(id);
        if (el) el.style.background = "white";
      }
    }
    this.Arr = [];
  }


  checkPermission() {
    return this.checkP.checkAccessPermission('slot_info', 'appointment', 'appointment')
  }

  onHover(data: any) {
    if (this.checkP.checkAccessPermission('slot_info', 'appointment', 'appointment') == false) {
      return
    }
    // this.checkDetail.push(data.slot_start_time)
    // if (data.slot_start_time == this.checkDetail[0]) {
    //   return
    // }
    // this.showSpinner = true;
    // if (data.total_booked == 0) {
    //   this.patientDetail = [];
    //   this.showSpinner = false
    //   return
    // }

    this.getSubject.next(data)
  }

  manipulateSlots(slots: any) {
    console.log("slots", slots);
    return slots
  }

  getSlotDetail(data) {
    if (data.total_booked == 0 && !data.waiting_booking) {
      this.patientDetail = [];
      this.status = data.reason == undefined ? "Available" : (this.auth.getUserType() != 'patient' ? data.reason : "Not Available");

      if (data && !data.reason && data.still_available == 0 && data.reserved_based_on_slot_no_for_op_billing) {
        this.status = "Not Available";
        this.showSpinner = false
        return
      }

      if (data.reason == undefined && data.slot_end_time < this.currentTime) {
        this.status = "Not Available";
      }
      this.showSpinner = false
      return
    }

    if (data.total_booked != 0 && data.waiting_booking && data.still_available != 0) {
      this.patientDetail = [];
      this.status = "Waiting Slot";
      if (data.reason == undefined && data.slot_end_time < this.currentTime) {
        this.status = "Not Available";
      }
      this.showSpinner = false
      return
    }

    if (this.auth.getUserType() == 'patient' && data.still_available == 0) {
      this.patientDetail = [];
      this.status = "Not Available";
      this.showSpinner = false
      return
    }

    if (!this.checkP.checkAccessPermission("show_all_slots", "appointment", "appointment")) {
      this.checkResponse(data)
      return
    }

    if (data.doctor_id) {
      let argument = "slotStartTime:" + data.slot_start_time + ",practitioner_id:" + data.doctor_id
      if (data.practice_type != undefined) {
        argument += ',practice_type:' + data.practice_type
      }
      if (this.appService.isFacilityAware()) {
        argument = argument + ",facility_id:" + data.facility_id
      }
      let obj = { args: argument }

      if (this.hideToolTip) {
        return
      }

      this.baseService.getData(obj, '', "appointment", "appointment", "GET_PATIENT_INFO_BY_SLOTTIME").pipe().subscribe((res: any) => {
        if (res) {
          this.patientDetail = res.resource;
          // // if (data.slot_start_time > this.currentTime)
          // //   this.status = "Remaining (" + data.still_available + ")"
          // else
          this.status = "";
          this.showSpinner = false
        }
      })
    } else {
      // this.checkResponse(data);
      if (data.reason == undefined && data.slot_end_time < this.currentTime) {
        this.patientDetail = [];
        this.status = "Not Available";
        this.showSpinner = false;
        return
      }

      if (data.reason == undefined && (data.total_booked == undefined || data.total_booked == 0)) {
        this.patientDetail = [];
        this.status = "Available";
        this.showSpinner = false;
        return
      }

      if (data.reason && (data.total_booked == undefined || data.total_booked == 0)) {
        this.patientDetail = [];
        this.status = data.reason;
        this.showSpinner = false;
        return
      }
      let argument = "slotStartTime:" + data.slot_start_time + ",serviceItemId:" + data.serviceItemId + ",serviceType_code:" + data.serviceType_code

      if (this.appService.isFacilityAware()) {
        argument = argument + ",facility_id:" + data.facility_id
      }
      let obj = { args: argument }

      if (this.hideToolTip) {
        return
      }

      this.baseService.getData(obj, '', "service_request", "order", "GET_OP_PACKAGE_SLOT_INFO").pipe().subscribe((res: any) => {
        if (res) {
          this.patientDetail = res.resource;
          // // if (data.slot_start_time > this.currentTime)
          // //   this.status = "Remaining (" + data.still_available + ")"
          // else
          this.status = "";
          this.showSpinner = false
        }
      })
    }
  }

  checkResponse(data) {
    if (data.reason == undefined && data.slot_end_time < this.currentTime) {
      this.patientDetail = [];
      this.status = "Not Available";
      this.showSpinner = false;
      return
    }

    if (data.reason == undefined && (data.total_booked == undefined || data.total_booked > 0)) {
      this.patientDetail = [];
      this.status = "Available";
      this.showSpinner = false;
      return
    }

    if (data.reason && (data.total_booked == undefined || data.total_booked == 0)) {
      this.patientDetail = [];
      this.status = data.reason;
      this.showSpinner = false;
      return
    }
  }

  changeDetail() {
    if (this.checkP.checkAccessPermission('slot_info', 'appointment', 'appointment') == false) {
      return
    }
    this.showSpinner = true;
    this.patientDetail = [];
  }

  applyStyle(slot) {
    if (!this.checkP.checkAccessPermission("show_all_slots", "appointment", "appointment")) {
      if (slot.status !== 'available' || slot.slot_end_time < this.currentTime) return { "border-width": "0px", "background-color": "#ebeef3", "cursor": "not-allowed" }
    } else {
      if (slot.vip == true) {
        if (slot.still_available == 0) {
          return { "border": "2px solid #4A90E2", "background-color": "#B8E986", "cursor": "not-allowed" }
        } else {
          return { "border": "2px solid #4A90E2", "background-color": "#B8E986" }
        }
      }
      if (slot.hasOwnProperty("reason")) {
        if (slot.reason == "OT") {
          return { "border": "2px solid #35C1B8", "background": "#35C1B8", "cursor": "not-allowed" }
        } else {
          return { "border": "2px solid #C17FCE", "background": "#C17FCE", "cursor": "not-allowed" }
        }
      } else if ((slot.doctor_over_booking_status == false || slot.over_booking == false) && slot.status !== 'available' && slot.still_available == 0) {
        return { "border": "2px solid #B8E986", "background": "#B8E986", "cursor": "not-allowed" }
      } else if ((slot.doctor_over_booking_status == true || slot.over_booking == true) && slot.status !== 'available' && slot.still_available == 0) {
        return { "border": "2px solid #B8E986", "background": "#B8E986", "cursor": "not-allowed" }
      } else if (slot.slot_end_time < this.currentTime && slot.still_available > 1 && slot.total_booked == 1) {
        return { "border": "2px solid #FB9026", "background": "#ebeef3", "cursor": "not-allowed" }
      } else if (slot.slot_end_time > this.currentTime && slot.still_available > 1 && slot.total_booked == 1) {
        return { "border": "2px solid #FB9026", "background": "#FFFFF" }
      } else if (slot.slot_end_time < this.currentTime && slot.total_booked >= 2) {
        return { "border": "2px solid #FB9026", "background": "#FB9026", "cursor": "not-allowed" }
      } else if (slot.slot_end_time > this.currentTime && slot.total_booked >= 2) {
        return { "border": "2px solid #FB9026", "background": "#FB9026" }
      } else if (slot.status !== 'available' || slot.slot_end_time < this.currentTime) {
        return { "border-width": "0px", "background-color": "#ebeef3", "cursor": "not-allowed" }
      } else if (slot.still_available == 1 && slot.total_booked == 1) {
        return { "border": "2px solid #FB9026", "background": "#FFFFF" }
      }
    }
  }

  checkTypeOfTimeSlots(slots) {
    return slots.length == undefined ? true : false;
  }

  checklenghtOfEmr(slots: any) {
    return (!Array.isArray(slots) && Object.keys(slots).length == 0) ? true : false
  }

  checkStyle() {
    if (this.auth.getUserType() == "patient" && (this.styleclass == 0 || this.styleclass == undefined)) {
      return { 'height': 'calc(100vh - 323px)', 'background': '#fff', 'overflow-y': 'auto', 'overflow-x': 'hidden' }
    } else if (this.styleclass) {
      return { 'height': `calc(100vh - ${this.styleclass}px)`, 'background': '#fff', 'overflow-y': 'auto', 'overflow-x': 'hidden' }
    } else {
      return { 'height': 'calc(100vh - 445px)', 'background': '#fff', 'overflow-y': 'auto', 'overflow-x': 'hidden' }
    }
  }

  clearSlotSelection(data?) {
    if (data.length > 1) {
      for (let i = 0; i < data.length - 1; i++) {
        let selectedSlot: HTMLElement = document.getElementById(this.Arr[i]);
        if (selectedSlot) {
          selectedSlot.style.background = "white";
        }
      }
      this.Arr.push("")
    }
  }


  getMultipleSlotSelection(slot) {
    const arr = slot?.schedule_service_multiplier;
    this.selectedPriority = this.selectedPriority ? this.selectedPriority : slot?.slot_selectedPriority;
    if (Array.isArray(arr) && arr.length > 0 && this?.selectedPriority) {
      if (this.selectedPriority) {
        this.slot_selection_limit = arr.find(s => s?.multiplier_priority === this?.selectedPriority)?.multiplier_slot_count ?? '';
        this.multipleSlots = !!this.slot_selection_limit;
      }
      if (this.slot_selection_limit && slot?.slot_selectedPriority) {
        this.multipleSlots = true;
        slot['slotFound'] = true;
      }
    }
    if (slot.doctor_screen && !slot?.schedule_service_multiplier) {
      this.multipleSlots = false;
    }
    return slot;
  }


  getAppointmentModeCss(slot) { // Only For Machine Slot Appointment Mode
    if (this.auth.getUserType() != 'patient') {
      if (slot?.machine_id && slot?.patient_Type === slot?.appointment_mode) {
        return { border: '2px solid #30eb0f' };
      }
      if (slot?.machine_id && slot?.patient_Type !== slot?.appointment_mode) {
        return { border: '2px solid #152de1' };
      }
    }
  }
}